export const CRM_DEVELOPMENT_GATE = 'crm-development-beta';
const FULL_DOCS_GATE = 'Developers:DeveloperDocumentation';
export const selectAuthState = state => state.auth;
export const selectAuthenticatedUser = state => state.auth.user;
export const selectAuthGates = state => state.auth.gates;
export const selectIsCRMDevUngated = state => state.auth.gates && state.auth.gates.includes(CRM_DEVELOPMENT_GATE);
export const selectIsFullDocsUngated = state => state.auth.gates && state.auth.gates.includes(FULL_DOCS_GATE);
export const selectIsPublicDocs = state => !state.auth.user;